module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAACE3AAAhNwEzWJ96AAABGklEQVRoge3WYa3CMBSG4e86QMIkTMIkIAEUXCTgAAmTgIRKGA6QwHUwws0hGU3bwTjdr/dJmpCQ7fRrT7cJAAAAAAAAAIAV/TiW6ia//yRdVorRSvqVtK9dqJF0knSVNGbG478+WgxvwWr3tQpsLGguZCn80a73coxquId+THZYEDYevbXiN3aJ+57XDHu19gqTNpsbYWG7bzP1Pbvnf/XiIjdrqyZzTWftf3MMntrZ0aFjXhwSBYZC0NxE53Y+2O6ltJlFH+3ebtpM2KXt073Z8sPkeJTeBK5hlTi3Xmfl3eCl4R5WiTPj/U5t7Kn96SvO9czGnhMKFWts7FlR2vVzrV1Nqf3FFGusXld7NwEAAAAAAAAAqELSHQuXxBDV8JwsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/ic_date@3x.png
// module id = 151
// module chunks = 0